<template>
    <div class="container">
        <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
            :cell-style="centerStyle">
            <el-table-column prop="ID" label="ID" width="55" align="center"></el-table-column>
            <el-table-column prop="userVoucherId" label="用户卡券ID" width="200" show-overflow-tooltip
                header-align="center"></el-table-column>
            <el-table-column prop="" label="用户称呼" show-overflow-tooltip header-align="center">
                <template #default="scope">
                    <span>{{ scope.row.user.real_name || scope.row.user.nickname }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="month" label="用户手机号" show-overflow-tooltip header-align="center">
                <template #default="scope">
                    <span>{{ scope.row.user.phone }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="month" label="操作人" show-overflow-tooltip header-align="center">
                <template #default="scope">
                    <span v-if="scope.row.manager.name!=''">{{ '店长：'+scope.row.manager.name }}</span>
                    <span v-else>{{  '管理员：'+scope.row.admin.name}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="month" label="操作类型" show-overflow-tooltip header-align="center">
                <template #default="scope">
                    <span>{{ scope.row.type==1?'赠送':'撤销' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="reason" label="备注" width="200" show-overflow-tooltip
            header-align="center"></el-table-column>
            <el-table-column prop="CreatedAt" label="操作日期" show-overflow-tooltip header-align="center"
                :formatter="dateRfcHMS"></el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination background layout="total, prev, pager, next" :current-page="query.page"
                :page-size="query.pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
        </div>
    </div>
</template>

<script>
import { getVoucherLog } from "../api/card_copons";
export default {
    name: "CardCoupons",
    data() {
        return {
            query: {
                page: 1,
                pageSize: 10,
            },
            tableData: [],
            pageTotal: 0,
            couponStatusMap: new Map([
                [1, '未使用'],
                [2, '已使用'],
                [3, '已过期']
            ]),
            limitInfo: [
                { value: 99999, label: '不限时间' },
                { value: 1, label: '1天' },
                { value: 3, label: '3天' },
                { value: 7, label: '7天' },
                { value: 15, label: '15天' },
                { value: 30, label: '30天' },
                { value: 60, label: '60天' },
                { value: 90, label: '90天' }
            ],
            limitMap: new Map()
        };
    },
    computed: {
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getData();
            this.getLimitMap()
        },

        getLimitMap() {
            this.limitInfo.forEach(item => {
                this.limitMap.set(item.value, item.label)
            })
        },
        dateRfcHMS: function (row, column) {
            const date = row[column.property];
            if (date === undefined || date === 0) {
                return "";
            }
            return new Date(+new Date(date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
        },

        centerStyle() {
            return 'text-align:center'
        },
        getData() {
            // this.tableData = []
            getVoucherLog(this.query).then(res => {
                this.tableData = res.data.list
                this.pageTotal = res.data.total
            })
        },


        // 触发搜索按钮
        // handleSearch() {
        //     this.getData()
        // },

        // 分页导航
        handlePageChange(val) {
            this.query.page = val
            this.getData()
        },
        // 用户列表分页导航
        handleUserPageChange(val) {
            this.user_query.page = val
            this.getUserList(this.user_query.voucherId)
        },

    }
};
</script>
<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.mr10 {
    margin-right: 10px;
}

.w200 {
    width: 200px;
}

.w400 {
    width: 400px !important;
}

.el-input,
.el-input-number {
    width: 220px;
    margin-right: 10px;
}

.el-select {
    width: 220px;
}


.box {
    margin: 0 auto;
}

.box .el-input {
    width: 60%;
}

.rowstyle {
    width: 100%;
    margin: 0 auto;
    padding-left: 15%;
}

.el-row {
    margin-bottom: 10px;
}

.el-col {
    border-radius: 4px;

}

.row-bg {
    padding: 5px 0;
    background-color: #f9fafc;
}

.grid-content {
    border-radius: 4px;
    min-height: 24px;
    text-align: center;
    line-height: 24px;
}

.tip {
    font-size: 12px;
    color: red;
}

.w350 {
    width: 350px;
}

.w250 {
    width: 250px;
}

.time-container {
    max-height: 400px;
    overflow-y: scroll;
}
</style>